import React, { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { TooltipProvider } from "@/components/ui/tooltip";
import RouteTracker from "./components/RouteTracker";
import AnalyticsBoot from "./components/AnalyticsBoot";

const Index = lazy(() => import("./pages/Index"));
const Services = lazy(() => import("./pages/Services"));
const About = lazy(() => import("./pages/About"));
const NotFound = lazy(() => import("./pages/NotFound"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Checklist = lazy(() => import("./pages/Checklist"));
const CampaignLanding = lazy(() => import("./pages/CampaignLanding"));
const TransitionLanding = lazy(() => import("./pages/TransitionLanding"));
const AnalyticsLocal = lazy(() => import("./pages/AnalyticsLocal"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const Ressources = lazy(() => import("./pages/Ressources"));
const CvQuebecois = lazy(() => import("./pages/guides/CvQuebecois"));
const LettrePresentation = lazy(() => import("./pages/guides/LettrePresentation"));
const RechercheEmploi = lazy(() => import("./pages/guides/RechercheEmploi"));
const PreparationEntrevue = lazy(() => import("./pages/guides/PreparationEntrevue"));
const OptimisationAts = lazy(() => import("./pages/guides/OptimisationAts"));
const ErreursCv = lazy(() => import("./pages/guides/ErreursCv"));
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const DiagnosticCV = lazy(() => import("./pages/outils/DiagnosticCV"));
const Chatbot = lazy(() => import("./components/Chatbot"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <AnalyticsBoot />
        <Toaster />
        <BrowserRouter>
          <Suspense fallback={null}>
            <RouteTracker />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/cv-ats" element={<CampaignLanding />} />
              <Route path="/cv-transition" element={<TransitionLanding />} />
              <Route path="/analytics-local" element={<AnalyticsLocal />} />
              <Route path="/merci" element={<ThankYou />} />
              <Route path="/thank-you" element={<Navigate to="/merci" replace />} />
              <Route path="/templates" element={<Navigate to="/services#packages" replace />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/checklist" element={<Checklist />} />
              <Route path="/ressources" element={<Ressources />} />
              <Route path="/guide/cv-quebecois" element={<CvQuebecois />} />
              <Route path="/guide/lettre-presentation" element={<LettrePresentation />} />
              <Route path="/guide/recherche-emploi" element={<RechercheEmploi />} />
              <Route path="/guide/preparation-entrevue" element={<PreparationEntrevue />} />
              <Route path="/guide/optimisation-ats" element={<OptimisationAts />} />
              <Route path="/guide/erreurs-cv" element={<ErreursCv />} />
              <Route path="/outils/diagnostic-cv" element={<DiagnosticCV />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Chatbot />
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
